var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"group-redactor"},[_c('span',{staticClass:"group-redactor__text group-redactor__text_light"},[_vm._v(" "+_vm._s(_vm.getRedactor)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }